class AnswerModel {
    questionNo: number = 0;
    choiceNo: string = "";
    choiceScore: string = "";
}

export {AnswerModel}